import React from 'react'
import baseSiteTheme from './baseSiteTheme'
import { MuiThemeProvider } from '@material-ui/core'
import AppHelmet from '../CreateACard/Layout/AppHelmet'
import Hero from '../ReviewsPage/Components/Hero'
import Reviews from '../ReviewsPage/Components/Reviews'

const ReviewsPage = () => {
    const pageTitle = window.React.pageTitle
    const pageDescription = window.React.pageDescription
    const h1 = window.React.h1
    const h1Content = window.React.h1Content
    const h2 = window.React.h2

    return (
        <>
            <MuiThemeProvider theme={baseSiteTheme}>
                <AppHelmet
                    pageTitle={pageTitle}
                    pageDescription={pageDescription}
                />
                <Hero
                    h1={h1}
                    h2={h2}
                    copy={h1Content}
                    imgSrc={
                        'https://res.cloudinary.com/gift-card-granny/image/upload/f_auto,w_310/v1657143236/GCG/assets/google-verified-reviews-transparent_qlg7cf.webp'
                    }
                    imgAltText={'Google Reviews'}
                />
                <Reviews />
            </MuiThemeProvider>
        </>
    )
}

export default ReviewsPage
